/** @file Sets an event's default int, float and string payloads (omitted fields keep their value). */
import { z } from 'zod';
import { skeletonParts } from '@pose2d/format/doc/schemaParts/skeleton';
import { defineCommand } from '../defineCommand';
import { entityDraft } from '../_shared/entityDraft';

/** event.setDefaults: merges the given payload fields; values equal to the current ones are a no-op (W2-31). */
export const command = defineCommand({
  name: 'event.setDefaults',
  description: 'Set the default payload of an event: value = any of int, float, string (keys may still override them).',
  input: z.object({ target: z.string().min(1), value: skeletonParts.event.pick({ int: true, float: true, string: true }).partial().strict() }).strict(),
  apply(draft, input, ctx) {
    const event = entityDraft(draft, 'event', ctx.resolve('event', input.target));
    if (Object.entries(input.value).every(([key, v]) => event[key] === v)) return;
    Object.assign(event, input.value);
    draft.meta.updatedAt = ctx.now;
  },
});
